module.exports = __webpack_public_path__ + "img/home-01.9baad4a6.svg";